import type { Incident } from '../../incidents/types/incident.types'

export interface CriticalIssueVM {
  id: number
  title: string
  dueAt: string | null
  createdAt: string
}

export interface BlockedTaskVM {
  id: number
  title: string
  reason: string
}

const CLOSED_STATUSES = new Set(['DONE', 'CLOSED'])

export function selectCriticalIssues(incidents: Incident[]): CriticalIssueVM[] {
  return incidents
    .filter((i) => i.priority === 'CRITICAL' && !CLOSED_STATUSES.has(i.status))
    .sort((a, b) => {
      if (a.due_at === b.due_at) return 0
      if (a.due_at === null) return 1
      if (b.due_at === null) return -1
      return new Date(a.due_at).getTime() - new Date(b.due_at).getTime()
    })
    .map((i) => ({ id: i.id, title: i.title, dueAt: i.due_at, createdAt: i.created_at }))
}

export function selectBlockedTasks(incidents: Incident[]): BlockedTaskVM[] {
  return incidents
    .filter((i) => i.status === 'BLOCKED')
    .map((i) => ({ id: i.id, title: i.title, reason: i.description ?? i.location ?? '—' }))
}

export function criticalRowLabel(vm: CriticalIssueVM, now: Date): string {
  if (vm.dueAt) {
    const due = new Date(vm.dueAt).getTime()
    if (due < now.getTime()) {
      const minutes = Math.max(1, Math.round((now.getTime() - due) / 60_000))
      return `Overdue ${minutes}m`
    }
  }
  const t = new Date(vm.createdAt)
  return `Reported ${t.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
}
